import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {DcpConfiguratorLoadingStagesToCheckoutComponent, UrlParamsGuard} from '@dcp/configurator';
import {ExpressCheckoutPageComponent} from '@app/pages/express-checkout/express-checkout-page/express-checkout-page.component';
import {BackUrlGuard} from '@app/checkout/guards/back-url.guard';
import {DynamicTransactionTypeAuthGuard} from '@app/checkout/guards/dynamic-transaction-type-auth.guard';
import {UserRegistrationGuard} from '@app/checkout/guards/user-registration.guard';
import {SuccessUrlGuard} from '@app/checkout/guards/success-url.guard';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'express-checkout/:productId',
        component: ExpressCheckoutPageComponent,
        canActivate: [
          UrlParamsGuard,
          DynamicTransactionTypeAuthGuard,
          UserRegistrationGuard,
          SuccessUrlGuard,
          BackUrlGuard,
        ],
      },
    ]),
    DcpConfiguratorLoadingStagesToCheckoutComponent,
    ExpressCheckoutPageComponent,
  ],
  exports: [RouterModule],
  schemas: [],
})
export class ExpressCheckoutPageModule {}
